import React, { forwardRef, useRef } from 'react';
import { Calendar as PrimeReactCalendar } from 'primereact/calendar';

function isCompleteDateRange(value) {
  return Array.isArray(value) && value[0] && value[1];
}

/**
 * PrimeReact 10.5 Calendar has no hideOnRangeSelection prop. If it is spread onto
 * the native input, React warns. Consume it here and hide the overlay when both
 * range dates are selected.
 */
export const Calendar = forwardRef(function Calendar(props, ref) {
  const { hideOnRangeSelection, onChange, ...rest } = props;
  const innerRef = useRef(null);

  const setRefs = (node) => {
    innerRef.current = node;
    if (typeof ref === 'function') ref(node);
    else if (ref) ref.current = node;
  };

  const handleChange = (event) => {
    if (typeof onChange === 'function') onChange(event);
    if (!hideOnRangeSelection) return;
    const mode = rest.selectionMode;
    if (mode !== 'range') return;
    if (!isCompleteDateRange(event?.value)) return;
    innerRef.current?.hide?.();
  };

  return (
    <PrimeReactCalendar
      ref={setRefs}
      onChange={handleChange}
      {...rest}
    />
  );
});
